import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["options", "endDateField", "preview", "previewBtn"]

  connect() {
    // Only initialize if the recurrence UI is present (feature flag enabled)
    if (this.hasOptionsTarget) {
      this.toggleRecurrence()
    }
  }

  toggleRecurrence(event) {
    // Only proceed if the recurrence UI is present (feature flag enabled)
    if (!this.hasOptionsTarget) return

    const checkbox = event?.target || this.element.querySelector('[name="reservation[repeat_freq]"]')
    const isRecurring = checkbox.checked

    if (isRecurring) {
      this.optionsTarget.style.display = 'block'
    } else {
      this.optionsTarget.style.display = 'none'
      // Clear preview when switching away from recurring
      if (this.hasPreviewTarget) {
        this.previewTarget.innerHTML = ''
      }
    }
  }

  toggleForever(event) {
    const isForever = event.target.checked
    this.endDateFieldTarget.disabled = isForever
  }

  async preview(event) {
    event.preventDefault()

    const form = this.element.closest('form')
    const formData = new FormData(form)

    // Extract the reservation params
    const params = new URLSearchParams({
      'reservation[member_id]': formData.get('reservation[member_id]') || '',
      'reservation[repeat_freq]': formData.get('reservation[repeat_freq]') || 'Never',
      'reservation[interval_weeks]': formData.get('reservation[interval_weeks]') || '1',
      'reservation[last_reservation_date]': formData.get('reservation[last_reservation_date]') || '',
      'reservation[forever]': formData.get('reservation[forever]') ? '1' : '0'
    })

    try {
      const response = await fetch(`${this.getNamespacePath()}/occurrences/${this.getOccurrenceId()}/reservations/preview_recurring?${params}`, {
        headers: { 'Accept': 'application/json' }
      })

      const data = await response.json()

      if (data.errors && data.errors.length > 0) {
        this.previewTarget.innerHTML = `
          <div class="alert alert-danger mb-0">
            <strong>Cannot create series:</strong>
            <ul class="mb-0">
              ${data.errors.map(e => `<li>${this.escapeHtml(e)}</li>`).join('')}
            </ul>
          </div>
        `
      } else if (data.occurrences && data.occurrences.length > 0) {
        const datesList = data.occurrences.slice(0, 10)
          .map(o => `<li>${this.escapeHtml(o.date)} - ${this.escapeHtml(o.title)}</li>`)
          .join('')
        const remaining = data.occurrences.length > 10 ? `<li>...and ${data.occurrences.length - 10} more</li>` : ''

        this.previewTarget.innerHTML = `
          <div class="alert alert-info mb-0">
            <strong>Will create ${data.occurrences.length} reservations:</strong>
            <ul class="mb-0">
              ${datesList}
              ${remaining}
            </ul>
          </div>
        `
      } else {
        this.previewTarget.innerHTML = `<div class="alert alert-warning mb-0">No matching occurrences found</div>`
      }
    } catch (error) {
      this.previewTarget.innerHTML = `<div class="alert alert-danger mb-0">Error loading preview: ${this.escapeHtml(error.message)}</div>`
      console.error('Preview error:', error)
    }
  }

  getOccurrenceId() {
    return document.querySelector('[name="occurrence_id"]')?.value || ''
  }

  getNamespacePath() {
    const namespace = document.querySelector('[name="namespace"]')?.value || 'branch'
    return `/${namespace}`
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
